import { AlertCircle } from "lucide-react";
import { useRouter } from "next/router";
import { useCreateWorkshopMutation } from "@/store/workshop-api";
import { getApiErrorMessage } from "@/store/api";
import styles from "./workshops.module.css";

export function WorkshopStartButton({
  className,
  children = "Start a session",
}: {
  className?: string;
  children?: React.ReactNode;
}) {
  const router = useRouter();
  const [create, result] = useCreateWorkshopMutation();
  const start = async () => {
    try {
      const created = await create({}).unwrap();
      await router.push(`/workshops/${created.session.id}`);
    } catch {
      /* RTK Query exposes the error below. */
    }
  };
  return (
    <div className={styles.startAction}>
      <button
        className={className ?? styles.primary}
        disabled={result.isLoading}
        onClick={start}
      >
        {result.isLoading ? "Starting…" : children}
      </button>
      {result.error && (
        <p className={styles.startError} role="alert">
          <AlertCircle size={16} aria-hidden="true" />
          {getApiErrorMessage(result.error, "Could not start session")}
        </p>
      )}
    </div>
  );
}
